<app-instructions-list [instructions]="instructions"></app-instructions-list>